import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ViConfirmDialogService, ViConfirmObject } from '@vi-iot/ui';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

import { AuthStore, CommercialStore, FetchedPartnerAccessInvitation } from '@store';

import { PillType } from '../../../../shared/components/pill/pill.model';
import { PartnerAccessShareDeviceModalComponent } from '../partner-access-share-device-modal/partner-access-share-device-modal.component';
import { InvitationStatusType } from '../../../../../projects/client';

@Component({
  selector: 'app-partner-access-settings-overlay',
  templateUrl: './partner-access-settings-overlay.component.html',
  styleUrls: ['./partner-access-settings-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerAccessSettingsOverlayComponent implements OnInit {
  readonly pillType = PillType;
  readonly invitationStatusType = InvitationStatusType;
  confirmObject: ViConfirmObject;

  constructor(
    public commercialStore: CommercialStore,
    public authStore: AuthStore,
    private translateService: TranslateService,
    private viConfirmModalService: ViConfirmDialogService,
    private dialog: MatDialog
  ) {}

  invitationVisibility(invitation: FetchedPartnerAccessInvitation): boolean {
    return (
      invitation.status === InvitationStatusType.Accepted ||
      invitation.status === InvitationStatusType.Pending ||
      invitation.isVisible
    );
  }

  ngOnInit(): void {
    this.commercialStore.fetchPartnerAccessList();
    this.initConfirmObject();
  }

  openShareDeviceMonitoringDialog(): void {
    this.dialog.open(PartnerAccessShareDeviceModalComponent, {
      panelClass: 'partner-access-share-device-dialog',
      autoFocus: false,
      disableClose: true,
    });
  }

  hidePartnerInvitation(invitation: FetchedPartnerAccessInvitation): void {
    this.commercialStore.updateInvitationVisibility(invitation.token, false);
  }

  removePartner(invitation: FetchedPartnerAccessInvitation): void {
    this.viConfirmModalService
      .open(this.confirmObject)
      .pipe(first())
      .subscribe((conditionAccepted) => {
        if (conditionAccepted) {
          this.commercialStore.removeInvitation(invitation.token, invitation.status);
        }
      });
  }

  private initConfirmObject(): void {
    this.confirmObject = {
      title: this.translateService.instant(
        '+INSTALLATIONS.PARTNER_ACCESS.SETTINGS_OVERLAY.CONFIRM_MODAL.TITLE'
      ),
      content: this.translateService.instant(
        '+INSTALLATIONS.PARTNER_ACCESS.SETTINGS_OVERLAY.CONFIRM_MODAL.CONTENT'
      ),
      cancelBtn: this.translateService.instant('GENERAL.BUTTON.CANCEL'),
      confirmBtn: this.translateService.instant(
        '+INSTALLATIONS.PARTNER_ACCESS.SETTINGS_OVERLAY.CONFIRM_MODAL.CONFIRM_BUTTON'
      ),
    };
  }
}
